import React, { FC, memo, useState } from 'react';
import { Card } from '../styl';

export interface IAcaoCatalogo {
    id: string;
    titulo: string;
    chave: string;
}
export interface IResourceCatalogo {
    id: string;
    titulo: string;
    // vazio = título de seção do menu (COLETAS, EMPRESA...), não uma tela
    link?: string | null;
    acoes: IAcaoCatalogo[];
}

interface IProps {
    resource: IResourceCatalogo;
    selecionadas: Set<string>;
    desabilitado?: boolean;
    onAlternar(chave: string): void;
    onMarcarTodos(chaves: string[]): void;
}

const CardResource: FC<IProps> = ({
    resource,
    selecionadas,
    desabilitado,
    onAlternar,
    onMarcarTodos,
}) => {
    const [aberto, setAberto] = useState(true);
    const chaves = resource.acoes.map(a => a.chave);
    const marcadas = chaves.filter(c => selecionadas.has(c)).length;
    const todos = chaves.length > 0 && marcadas === chaves.length;

    if (resource.acoes.length === 1) {
        const [acao] = resource.acoes;
        return (
            <Card>
                <label className="unica">
                    <span className="nome">
                        <strong>{resource.titulo}</strong>
                        <small>{resource.id}</small>
                    </span>
                    <span className="acao-unica">
                        {acao.titulo}
                        <input
                            type="checkbox"
                            checked={selecionadas.has(acao.chave)}
                            disabled={desabilitado}
                            onChange={() => onAlternar(acao.chave)}
                        />
                    </span>
                </label>
            </Card>
        );
    }

    return (
        <Card>
            <header>
                <div className="nome">
                    <h3>{resource.titulo}</h3>
                    <small>{resource.id}</small>
                </div>
                <span className={`contagem ${todos ? 'cheio' : ''}`}>
                    {marcadas}/{chaves.length}
                </span>
                <button
                    type="button"
                    className={`colapsar ${aberto ? '' : 'fechado'}`}
                    aria-label={`${aberto ? 'Recolher' : 'Expandir'} ${
                        resource.titulo
                    }`}
                    aria-expanded={aberto}
                    onClick={() => setAberto(v => !v)}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                    >
                        <path d="M4 6l4 4 4-4" />
                    </svg>
                </button>
            </header>
            {aberto && (
                <div className="corpo">
                    <button
                        type="button"
                        className="marcar-todos"
                        disabled={desabilitado}
                        onClick={() => onMarcarTodos(chaves)}
                    >
                        {todos ? 'Desmarcar todos' : 'Marcar todos'}
                    </button>
                    <div className="acoes">
                        {resource.acoes.map(acao => (
                            <label key={acao.chave}>
                                <input
                                    type="checkbox"
                                    checked={selecionadas.has(acao.chave)}
                                    disabled={desabilitado}
                                    onChange={() => onAlternar(acao.chave)}
                                />
                                {acao.titulo}
                            </label>
                        ))}
                    </div>
                </div>
            )}
        </Card>
    );
};
export default memo(CardResource);
